import * as nonNull from "@neonaut/lib-js/nonNullable";
import getExtent from "../feature/getExtent";
import combineExtents from "../extents/combineExtents";
export default function getExtentForFeatures(features) {
    return combineExtents(features.map(getExtent).filter(nonNull.is));
}
